var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#59975C",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8093 24.9124L10.3567 19.626L8.5 21.4135L15.8093 28.5L31.5 13.2875L29.6563 11.5L15.8093 24.9124Z",
    fill: "#59975C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.a02258f6daee8c522f5fb38e79815e88.svg";
export { ForwardRef as ReactComponent };